import React, { useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import "./yourretirementchoices.scss";
import { ModalOverlay } from "../../atoms/Modal";
import CustomAccordion from "../../atoms/CustomAccordion";
import dayjs from "dayjs";
import { Icons } from "../../atoms/Icons";
import { choicesData } from "../../../src/data/retirementChoices";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../../redux/actions";
import { addCommas } from "../../helpers/helpers";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../atoms/Loader";

const YourRetirementChoices = (props) => {
  const { fetching, choose, data } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const chooseOptions =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  const [annualAllowance, setAnnualAllowance] = useState(false);
  const [limitations, setLimitations] = useState(false);
  const [mIC, setMiC] = useState(false);
  const [mixMatch, setMixMatch] = useState(false);
  const dispatch = useDispatch();

  const { retirementChoiceSubStepHandler, startPotSelectionAgainHandler } =
    bindActionCreators(
      actionCreators,
      dispatch // eslint-disable-line
    );
  const applyingWith =
    Object.keys(choose).length === 0 ? (
      <span className="text-style">
        £
        {addCommas(
          Math.trunc(
            parseFloat(chooseOptions?.monetaryChosenAmount) // eslint-disable-line
          ) // eslint-disable-line
        )}
        .
        <span className="eac-pot-value-small-digit">
          {(parseFloat(chooseOptions?.monetaryChosenAmount) % 1)
            .toFixed(2)
            .substring(2)}
        </span>
      </span>
    ) : (
      <span className="text-style">
        £
        {addCommas(
          Math.trunc(
            parseFloat(data?.choose?.monetaryChosenAmount) // eslint-disable-line
          ) // eslint-disable-line
        )}
        .
        <span className="eac-pot-value-small-digit">
          {(parseFloat(data?.choose?.monetaryChosenAmount) % 1)
            .toFixed(2)
            .substring(2)}
        </span>
      </span>
    );
  const [openIndex, setOpenIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const isActiveMember = props?.isActiveMember;

  const handleButtonClick = (itemTitle) => {
    switch (itemTitle) {
      case "Take all your money in one go":
        setAnnualAllowance(true);
        setMiC(false);
        break;
      case "Take tax-free cash and invest the rest":
        retirementChoiceSubStepHandler({
          isTakeTaxFreeCashInvestRest: true,
        });
        break;
      case "Take your money in chunks, a bit at a time":
        setAnnualAllowance(true);
        setMiC(true);
        break;
      case "Take a guaranteed income (annuity)":
        retirementChoiceSubStepHandler({
          isAnnuityHowMuchCash: true,
          activeUser: isActiveMember,
        });
        break;
      case "Take a regular income from TPT drawdown":
        if (chooseOptions?.monetaryChosenAmount < 30000) {
          setLimitations(true);
          setMixMatch(false);
        } else {
          retirementChoiceSubStepHandler({
            isRegularHowMuchCash: true,
            activeUser: isActiveMember,
          });
        }
        break;
      case "Mix and match":
        if (chooseOptions?.monetaryChosenAmount < 30000) {
          setLimitations(true);
          setMixMatch(true);
        } else {
          retirementChoiceSubStepHandler({
            isMixMatchHowMuchCash: true,
            activeUser: isActiveMember,
          });
        }
        break;
      default:
        break;
    }
  };
  if (fetching) {
    return <LoadingSpinner />;
  }
  return (
    <>
      <Card className="your-retirement-choices">
        <Card.Body className="p-0">
          <Row>
            <Col md={7} className="mb-fourty">
              <p className="guidance">Your retirement choices</p>
              <p>
                This is where you select which of the options you want to use
                for your retirement.
              </p>
            </Col>
            <Col md={5} className="total-pot-apply">
              <p className="btn-card">
                Applying with
                <br />
                {applyingWith}
              </p>
              <div className=" m-42 d-flex align-items-center date-tooltip">
                <div className="value-correct-date">
                  {" "}
                  Values correct as of {todayDate}
                </div>

                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Popover
                      id="popover-contained"
                      className="tooltip-popover-section"
                    >
                      <Popover.Body className="tooltip-popover-body">
                        <p>
                          {" "}
                          All the values are estimates, based on the most
                          accurate information available. They include all the
                          contributions paid by you and your employer.
                        </p>
                        <p>
                          The value of your pension savings is based on current
                          financial conditions and is not guaranteed. The
                          amounts you receive may be higher or lower than the
                          amounts shown above. Payment of your pension will be
                          subject to TPT’s Trust Deed and Rules, and regulatory
                          requirements.
                        </p>{" "}
                      </Popover.Body>
                    </Popover>
                  }
                  flip={true}
                >
                  <span className="textarea-tooltip">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
              </div>
            </Col>
          </Row>
          {choicesData?.map((item, index) => {
            return (
              <Row className="ourter-bg custom-accordion" key={index}>
                <CustomAccordion
                  key={index}
                  eventKey={index}
                  isOpen={openIndex === index}
                  identifier={`valueTest`}
                  contentSection1="one-column"
                  bgColor="bg-turquoise"
                  headertext={item.title}
                  innerContent={item.innerContent}
                  yrcDescription={item.description}
                  variant="icon-fourty-px"
                  iconname={item.iconname}
                  headingNav="Read more"
                  headingNavClose="Read less"
                  handleClick={() => handleAccordionClick(index)}
                  handleButtonClick={() => handleButtonClick(item.title)}
                  btnName="Select this option"
                  applyShadow={true}
                />
              </Row>
            );
          })}
        </Card.Body>
      </Card>
      <ModalOverlay
        popup="annualAllowance"
        show={annualAllowance}
        headTitle="Money purchase annual allowance"
        description="Making a direct withdrawal from your pension savings will trigger the money purchase annual allowance (MPAA). This will reduce the amount that you and your employer can make into direct contribution (DC) pension savings before paying tax from the annual allowance of £60,000, to the MPAA of £10,000 a year. The MPAA will apply for the rest of this tax year, and all subsequent tax years, although the amount may change in the future."
        btnSendName="Confirm"
        handleClick={() => {
          if (mIC) {
            retirementChoiceSubStepHandler({
              isTakeMoneyInOneChunk: true,
              activeUser: isActiveMember,
            });
          } else {
            retirementChoiceSubStepHandler({
              isTakeMoneyInOneGo: true,
              activeUser: isActiveMember,
            });
          }

          setAnnualAllowance(false);
        }}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setAnnualAllowance(false);
        }}
      />
      <ModalOverlay
        popup="limitationsYourChoices"
        show={limitations}
        headTitle="Limitations to your choices"
        description={<>You are currently retiring with {applyingWith}</>}
        descriptionOne="You will be able to set up regular income from flexi-access drawdown only."
        descriptionTwo="If you wish to access regular income managed for you (managed income or future annuity income), you need to retire with a minimum of £30,000 before tax-free cash. You’ll need to add other TPT pots to this application or transfer-in other pensions to access these options."
        btnContinuedName="Continue"
        btnUserOtherName={
          parseFloat(data?.totalPotAmount) >= 30000 ? "Start again" : ""
        }
        handleClick={() => {
          if (mixMatch) {
            retirementChoiceSubStepHandler({
              isMixMatchHowMuchCash: true,
              activeUser: isActiveMember,
            });
          } else {
            retirementChoiceSubStepHandler({
              isRegularHowMuchCash: true,
              activeUser: isActiveMember,
            });
          }

          setLimitations(false);
        }}
        handleTimeline={() => {
          startPotSelectionAgainHandler();
          setLimitations(false);
        }}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setLimitations(false);
        }}
      />
    </>
  );
};

export default YourRetirementChoices;
